import { IconAlertCircle, IconShoppingCart } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useBuyCreditPath } from '../../store/paymentConfigStore';

const LimitReachedModal = ({ opened, onClose, isOperator = false }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const buyCreditPath = useBuyCreditPath();

    const handleBuyCredits = () => {
        onClose();
        navigate(buyCreditPath);
    };

    return (
        <Dialog open={opened} onOpenChange={(v) => !v && onClose()}>
            <DialogContent className="max-w-sm">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-red-100 dark:bg-red-900/30">
                            <IconAlertCircle size={18} className="text-red-600 dark:text-red-400" />
                        </span>
                        <span className="text-base font-semibold">{t('limitReached.title')}</span>
                    </DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-4">
                    {isOperator ? (
                        <>
                            <p className="text-sm text-zinc-700 dark:text-zinc-300">{t('limitReached.operatorMessage')}</p>
                            <div className="flex justify-end">
                                <button
                                    onClick={onClose}
                                    className="px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                                >
                                    {t('limitReached.understood')}
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="text-sm text-zinc-700 dark:text-zinc-300">{t('limitReached.userMessage')}</p>
                            <div className="flex justify-end gap-2">
                                <button
                                    onClick={onClose}
                                    className="px-4 py-2 text-sm font-medium text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded-md transition-colors"
                                >
                                    {t('limitReached.understood')}
                                </button>
                                <button
                                    onClick={handleBuyCredits}
                                    className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                                >
                                    <IconShoppingCart size={15} />
                                    {t('limitReached.buyCredits')}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default LimitReachedModal;
